import { Component, EventEmitter, Input } from '@angular/core';
import { PriceBandListQueryFilter } from './price-band-list-query-filter';
import { PriceBand } from '../models/price-band';
import { SessionService } from 'src/app/shared/services/session.service';
import { MatDialog } from '@angular/material/dialog';
import { BaseComponent } from 'src/app/core/base.component';
import { PriceBandService } from '../services/price-band.service';
import { Sort } from '@angular/material/sort';
import { PriceBandCreateModalComponent } from '../modals/price-band/price-band-create-modal/price-band-create-modal.component';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';
import { AlertModalComponent } from 'src/app/shared/modals/alert-modal/alert-modal.component';

@Component({
    selector: 'price-bands-list',
    templateUrl: './price-bands-list.component.html',
    styleUrl: './price-bands-list.component.scss',
    standalone: false
})
export class PriceBandsListComponent extends BaseComponent{
  @Input() filter: PriceBandListQueryFilter = new PriceBandListQueryFilter();
  public updateFilterEvent = new EventEmitter<any>();
  public priceBands: PriceBand[] = [];

  constructor(sessionService: SessionService,
    private priceBandService: PriceBandService,
    private dialog: MatDialog,
    stringHelpers: StringHelpers) {
    super(sessionService, stringHelpers);
    this.displayedColumns = ['name', 'description', 'lastEditedDate', 'actions'];
    this.filter.organizationId = this.sessionService.getUser().organizationId;
  }

  ngOnInit(): void {
    this.getPriceBands();
  }

  getPriceBands(){
    this.isLoading = true;
    this.priceBandService.getAllByOrganization(this.filter).subscribe({
      next: (result) => {
        this.priceBands = result.results;
        this.filter.totalCount = result.totalCount;
        this.updateFilterEvent.emit(result.results);
      },
      error: (error) => {
        this.isLoading = false;
        console.error(error);
      },
      complete: () => this.isLoading = false
    });
  }

  sortData(sort: Sort) {
    this.filter.sortDirection = sort.direction;
    this.filter.sortColumn = sort.active;
    this.getPriceBands();
  }

  resetFilter() {
    this.filter.page = 1;
    this.filter.text = '';
    this.filter.pageSize = 15;
  }

  createPriceBand(){
    const dialogRef = this.dialog.open(PriceBandCreateModalComponent, {
      width: '40vw'
    });
    
    dialogRef.afterClosed().subscribe(result => {
      if(result === "save"){
        this.getPriceBands();
      }
    });
  }

  delete(priceBand: PriceBand){
    const dialogRef = this.dialog.open(AlertModalComponent);
    dialogRef.componentInstance.title = 'Delete Price Band';
    dialogRef.componentInstance.body = `<h3 class="text-danger mat-h3">WARNING! THIS ACTION CANNOT BE UNDONE</h3> <br /> Are you sure you want to delete Price Band <strong>${priceBand.name}</strong>?`;
    dialogRef.componentInstance.submitText = 'Yes';
    dialogRef.componentInstance.otherText = 'No';
    dialogRef.componentInstance.isOtherTextDisabled = false;
    dialogRef.afterClosed().subscribe((response) => {
      if(response === 'Yes'){
        this.isLoading = true;
        let data = {id: priceBand.id, lastEditedBy: this.getUserIdFromSession()};
        this.priceBandService.delete(data).subscribe({
          next: () => {
            this.getPriceBands();
            this.isLoading = false;
          },
          error: (error) => {
            this.isLoading = false;
            this.alert('Error', error.error.errors.Id[0]);
            console.error(error); 
          },
          complete: () => this.isLoading = false
        });
      }
    });
  }

  alert(title: string, message: string){
    const dialogRef = this.dialog.open(AlertModalComponent);
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.body = message;
    dialogRef.componentInstance.submitText = 'Okay';
    dialogRef.componentInstance.isOtherTextDisabled = true;
  } 
}
